import { render } from "./TotalPoints30DaysRanking.vue?vue&type=template&id=a5f84dfc"
import script from "./TotalPoints30DaysRanking.vue?vue&type=script&lang=js"
export * from "./TotalPoints30DaysRanking.vue?vue&type=script&lang=js"

import exportComponent from "/Users/lasse/Documents/DOFprojects/spontanpunkt-PWA/pwa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__